export class AdminClaimJSON {
  impersonate?: number;
}
